import React, { useState } from "react";
import CustomerListContainer from "../CustomerListContainer/CustomerListContainer";
import { useSelectedSystems } from "../../hooks/useCloudSelectors";
import EditViewContainer from "../EditViewContainer/EditViewContainer";
import { useDispatch } from "react-redux";
import { changeCreateCustomerViewState } from "../../ducks/customersDuck";

import { Box, Button, IconButton, Tooltip, useMediaQuery, useTheme } from "@mui/material";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const AdminContainer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const dispatch = useDispatch();
  const selectedSystems = useSelectedSystems();

  const [showSidebar, setShowSidebar] = useState(true);

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        borderTop: `1px solid ${theme.palette.primary.main}`,
        overflow: "hidden",
      }}
    >
      {/* Top toolbar */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          px: 2,
          py: 1,
          borderBottom: `1px solid ${theme.palette.divider}`,
          bgcolor: "background.paper",
          flexShrink: 0,
        }}
      >
        <Button
          variant="contained"
          startIcon={<AddBusinessIcon />}
          onClick={() => dispatch(changeCreateCustomerViewState())}
          size="small"
        >
          Add Site
        </Button>
      </Box>

      {/* Sidebar + edit area */}
      <Box sx={{ display: "flex", flex: 1, overflow: "hidden" }}>
        {!isMobile && (
          <Box
            sx={{
              width: showSidebar ? { lg: 350, xl: 370 } : 0,
              minWidth: showSidebar ? { lg: 350, xl: 370 } : 0,
              transition: "width 0.25s ease, min-width 0.25s ease",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              bgcolor: "background.dark",
              borderRight: showSidebar ? `1px solid ${theme.palette.primary.main}` : "none",
            }}
          >
            <Box sx={{ overflowY: "auto", flex: 1 }}>
              <CustomerListContainer selectedSystems={selectedSystems} />
            </Box>
          </Box>
        )}

        {/* Sidebar toggle */}
        {!isMobile && (
          <Tooltip title={showSidebar ? "Hide sites" : "Show sites"} placement="right">
            <IconButton
              onClick={() => setShowSidebar((prev) => !prev)}
              size="small"
              sx={{
                position: "absolute",
                left: showSidebar ? { lg: 350, xl: 370 } : 0,
                top: "50%",
                transform: "translateY(-50%)",
                zIndex: 1000,
                bgcolor: "background.light",
                border: "1px solid",
                borderColor: "divider",
                borderRadius: "0 4px 4px 0",
                transition: "left 0.25s ease",
                "&:hover": { bgcolor: "action.hover" },
                width: 24,
                height: 48,
              }}
            >
              {showSidebar ? <ChevronLeftIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />}
            </IconButton>
          </Tooltip>
        )}

        {/* Edit area */}
        <Box sx={{ flex: 1, overflowY: "auto", p: 3, minWidth: 0 }}>
          <EditViewContainer />
        </Box>
      </Box>
    </Box>
  );
};

export default AdminContainer;